import React, { useCallback, useState, VFC } from 'react'

import SVGCheckmark from '@Assets/SVG/Check'
import { StyledButtonWithProgress } from '@Components/BuyButton/styledElements'
import { SVGIcon } from '@Components/Icons'
import { useAddToCart, UseAddToCartProps } from '@Globals/Cart/useAddToCart'
import { useTranslation } from '@Globals/Translations'

export const SmallBuyButton: VFC<UseAddToCartProps> = (props) => {
  const { callback: addToCart, inProgress } = useAddToCart({
    disableFlow: true,
    ...props,
  })
  const { t } = useTranslation()
  const [hasAdded, setHasAdded] = useState(false)

  const onClick = useCallback(async () => {
    if (hasAdded) {
      return
    }

    // TODO: Handle errors?
    await addToCart()
    setHasAdded(true)
  }, [addToCart, hasAdded])

  return (
    <StyledButtonWithProgress
      disabled={inProgress || hasAdded}
      loading={inProgress}
      onClick={onClick}
      size="small"
      variant="outlined"
    >
      {hasAdded ? <SVGIcon color="blue" icon={SVGCheckmark} /> : t('cart:ADD_TO_CART_SHORT')}
    </StyledButtonWithProgress>
  )
}
